import TextEffectsSharedMapper from '../../TextEffectsShared/viewer/TextEffectsShared.mapper';

export default TextEffectsSharedMapper;
